module.exports = __webpack_public_path__ + "static/img/14000786.fc3b9759.png";